<template>
  <div class="content-container flex-row">
    <a href="javascript:;" class="button action fixed right" @click="openEditModal()">
      Ny Label
    </a>

    <section class="content large-padding white">
      <h2>Kunst / Nett ({{items.length}})</h2>

      <TheLoader :active="loading || updating" :update="updating"/>

      <table v-if="!loading" class="large fixed visible clickable sortable" style="width: 100%">
        <thead>
          <tr>
            <th class="unsortable">#</th>
            <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === params.sort ? sortClass : '']" @click="sortBy(heading.sortKey)">
              {{heading.name}}
              <span id="sorttable_sortrevind" v-if="heading.sortKey === params.sort && params.direction === 'DESC'">&nbsp;</span>
              <span id="sorttable_sortfwdind" v-if="heading.sortKey === params.sort && params.direction !== 'DESC'">&nbsp;</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" v-bind:key="item.Labelid" @click="openEditModal(item)">
            <td>
              {{ index + 1}}
            </td>
            <td>{{item.Labelid}}</td>
            <td>{{item.Navn}}</td>
            <td>{{item.Engelsk || '-'}}</td>
            <td class="align-right">{{item.Kategori || 'Alle'}}</td>
            <td class="align-right">{{item.Dato | avantidatetime}}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'
import LabelService from '@/services/LabelService'

export default {
  name: 'LabelArt',
  data () {
    return {
      loading: true,
      updating: false,
      params: {
        type: 'K',
        sort: 'Labelid',
        direction: 'DESC'
      },
      headings: [
        { name: 'Labelid', sortKey: 'Labelid', class: '' },
        { name: 'Navn', sortKey: 'Navn', class: '' },
        { name: 'Engelsk', sortKey: 'Engelsk', class: '' },
        { name: 'Kategori', sortKey: 'Kategori', class: 'align-right' },
        { name: 'Opprettet', sortKey: 'Dato', class: 'align-right' }
      ],
      items: []
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Label Kunst / Nett'
    },
    sortClass: function () {
      return 'sorttable_sorted' + (this.reverse ? '_reverse' : '')
    }
  },
  created () {
    bus.$off('label-saved')
    bus.$off('label-deleted')

    this.loading = true
    this.fetch()
  },
  mounted () {
    bus.$on('label-saved', (item) => this.onLabelSaved(item))
    bus.$on('label-deleted', (item) => this.onLabelDeleted(item))
  },
  methods: {
    openEditModal: function (item = null) {
      this.openModal(
        'label-modal',
        {
          item: item,
          type: 'K'
        }
      )
    },
    onLabelSaved: function (item) {
      const index = this.items.findIndex(i => i.Labelid === item.Labelid)

      if (index !== -1) {
        // Found item
        if (item.labeltype === 'K') {
          // Update if same labeltype
          this.$set(this.items, index, item)
        } else {
          // Delete if not same labeltype
          this.items.splice(index, 1)
        }
      } else if (item.labeltype === 'K') {
        // Did not find item, but new item has same labeltype, so append it.
        this.items.unshift(item)
      }
    },
    onLabelDeleted: function (item) {
      const index = this.items.findIndex(i => i.Labelid === item.Labelid)
      if (index !== -1) {
        this.items.splice(index, 1)
      }
    },
    sortBy: function (sortKey) {
      if (this.params.sort === sortKey) {
        this.$set(this.params, 'direction', this.params.direction === 'ASC' ? 'DESC' : 'ASC')
      } else {
        this.$set(this.params, 'direction', 'ASC')
      }
      this.$set(this.params, 'sort', sortKey)

      this.updating = true
      this.fetch()
    },
    fetch: function () {
      LabelService.loadByType(this.params)
        .then((response) => {
          this.items = response.data

          console.log(response)
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn labels')
        })
        .then(() => {
          this.loading = false
          this.updating = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/Label/LabelArt.vue